import * as i18nIsoCountries from 'i18n-iso-countries'

import {Locale} from '@/utils/constants'
import {Jurisdiction, NotOfferedJurisdiction} from '@/utils/countries/constants'

i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/sk.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/cs.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/en.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/es.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/de.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/fr.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/it.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/pl.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/pt.json'))

const countryNameOverrides: Partial<Record<Locale, Record<string, string>>> = {
  [Locale.sk]: {
    [Jurisdiction.EU]: 'Európska únia',
    [Jurisdiction.BX]: 'Benelux',
    [Jurisdiction.UK]: 'Spojené kráľovstvo',
    [Jurisdiction.US]: 'USA',
    [Jurisdiction.HK]: 'Hongkong',
    [Jurisdiction.CD]: 'Kongo (KDR)',
    [Jurisdiction.OA]: 'OAPI',
    [Jurisdiction.AP]: 'ARIPO',
    [NotOfferedJurisdiction.WO]: 'WIPO',
  },
  [Locale.cs]: {
    [Jurisdiction.EU]: 'Evropská unie',
    [Jurisdiction.BX]: 'Benelux',
    [Jurisdiction.UK]: 'Spojené království',
    [Jurisdiction.US]: 'USA',
    [Jurisdiction.CZ]: 'Česko',
    [Jurisdiction.ZA]: 'Jižní Afrika',
    [Jurisdiction.CD]: 'Kongo (KDR)',
    [Jurisdiction.OA]: 'OAPI',
    [Jurisdiction.AP]: 'ARIPO',
    [NotOfferedJurisdiction.WO]: 'WIPO',
  },
  [Locale.en]: {
    [Jurisdiction.EU]: 'European Union',
    [Jurisdiction.BX]: 'Benelux',
    [Jurisdiction.UK]: 'United Kingdom',
    [Jurisdiction.US]: 'United States',
    [Jurisdiction.CN]: 'China',
    [Jurisdiction.SK]: 'Slovak Republic',
    [Jurisdiction.TW]: 'Taiwan',
    [Jurisdiction.TZ]: 'Tanzania',
    [Jurisdiction.CD]: 'Congo (DRC)',
    [Jurisdiction.LA]: 'Laos',
    [Jurisdiction.MD]: 'Moldova',
    [Jurisdiction.OA]: 'OAPI',
    [Jurisdiction.AP]: 'ARIPO',
    [NotOfferedJurisdiction.WO]: 'WIPO',
  },
  [Locale.es]: {
    [Jurisdiction.EU]: 'Unión Europea',
    [Jurisdiction.BX]: 'Benelux',
    [Jurisdiction.UK]: 'Reino Unido',
    [Jurisdiction.OA]: 'OAPI',
    [Jurisdiction.AP]: 'ARIPO',
    [NotOfferedJurisdiction.WO]: 'WIPO',
  },
  [Locale.de]: {
    [Jurisdiction.EU]: 'Europäische Union',
    [Jurisdiction.BX]: 'Benelux',
    [Jurisdiction.UK]: 'Vereinigtes Königreich',
    [Jurisdiction.OA]: 'OAPI',
    [Jurisdiction.AP]: 'ARIPO',
    [NotOfferedJurisdiction.WO]: 'WIPO',
  },
  [Locale.fr]: {
    [Jurisdiction.EU]: 'Union européenne',
    [Jurisdiction.BX]: 'Benelux',
    [Jurisdiction.UK]: 'Royaume-Uni',
    [Jurisdiction.OA]: 'OAPI',
    [Jurisdiction.AP]: 'ARIPO',
    [NotOfferedJurisdiction.WO]: 'WIPO',
  },
  [Locale.it]: {
    [Jurisdiction.EU]: 'Unione europea',
    [Jurisdiction.BX]: 'Benelux',
    [Jurisdiction.UK]: 'Regno Unito',
    [Jurisdiction.OA]: 'OAPI',
    [Jurisdiction.AP]: 'ARIPO',
    [NotOfferedJurisdiction.WO]: 'WIPO',
  },
  [Locale.pl]: {
    [Jurisdiction.EU]: 'Unia Europejska',
    [Jurisdiction.BX]: 'Beneluks',
    [Jurisdiction.UK]: 'Zjednoczone Królestwo',
    [Jurisdiction.OA]: 'OAPI',
    [Jurisdiction.AP]: 'ARIPO',
    [NotOfferedJurisdiction.WO]: 'WIPO',
  },
  [Locale.pt]: {
    [Jurisdiction.EU]: 'União Europeia',
    [Jurisdiction.BX]: 'Benelux',
    [Jurisdiction.UK]: 'Reino Unido',
    [Jurisdiction.OA]: 'OAPI',
    [Jurisdiction.AP]: 'ARIPO',
    [NotOfferedJurisdiction.WO]: 'WIPO',
  },
}

export const alpha2ToName = (countryCode: string | null | undefined, language: Locale) => {
  if (countryCode) {
    const override = countryNameOverrides?.[language]?.[countryCode]
    if (override) {
      return override
    } else {
      return i18nIsoCountries.getName(countryCode, language, {select: 'official'}) ?? countryCode
    }
  } else {
    return countryCode ?? ''
  }
}
